export default {
  reason: "Incidence Reason",
  priority: " Priority",
};
